const styles = {
  primaryHeading: "font-medium text-6xl md:text-8xl",
  secondaryHeading: "font-medium text-4xl md:text-6xl mb-8",
  tertiaryHeading: "font-medium text-2xl md:text-4xl",
  quartiaryHeading: "font-medium text-xl md:text-2xl",
  standardText: "font-normal",
  standardTextBold: "font-bold",
  hoverShrinkEffect: "hover:scale-[0.85] transition ease-in-out",
  button:
    "text-lg text-white p-5 bg-green-500 hover:bg-green-400 rounded-xl w-fit h-fit"
};

export const animationDelays = {
  delay1: { "--animationDelay": "0.2s" } as React.CSSProperties,
  delay2: { "--animationDelay": "0.5s" } as React.CSSProperties,
  delay3: { "--animationDelay": "0.7s" } as React.CSSProperties,
  delay4: { "--animationDelay": "0.9s" } as React.CSSProperties
};

export default styles;
